export default {"src":"/_next/static/media/play-round.67b71935.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};